export default {
  'claimCount': 'Recuento de Reclamaciones',
  'totalClaimsCompletedByDayMonth': 'Total de Reclamaciones Completadas por Día/Mes',
  'byMonthAndStatus': 'Reclamaciones por Mes y Estado',
};